import React from 'react';
import { connect } from 'react-redux';

import { flightsCountSelector } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';
import { getIsMobile } from 'src/store/view/selectors';
import { getIsFeatureHasAnOption } from 'src/utils/featureToggle';

import { Plane } from '@lt/components/icons-react/userflow';
import { i18n } from '@lt/localization';
import { isFlightListLoading } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights-filters';
import { getArchivedAt } from 'checkout/store/selectors/package';
import {
  EXPERIMENT_NAMES,
  Experiment,
  Variant,
} from 'src/components/Experiment';
import styled from 'styled-components';
import { FlightsNoResults } from '../../../components/Flights';
import FlightClassSwitcher from '../FlightClassSwitcher';

import FlightsProgressbar from '../../../components/Flights/FlightsProgressbar';

import InformationAboutFlightTypes from '../../../components/InformationAboutFlightTypes';
import FlightsLoadingResults from './components';
import { FLIGHT_LIST_ID } from './constants';
import LuggageFilterPanelComponent from '../../../components/LuggageFilterPanel';

const baseCls = 'checkout-flights';

interface FlightsListProps {
  isLoading: boolean;
  flightsCount: number;
  isMobile: boolean;
  archivedAt?: boolean;
}

class FlightsList extends React.PureComponent<FlightsListProps> {
  render() {
    const { isLoading, flightsCount, isMobile, archivedAt } = this.props;
    const hasResults = flightsCount > 0;

    return (
      <div>
        <FlightsPickerTitle>
          {i18n.t('checkout.flight.title')}
          <Plane width={32} height={32} />
        </FlightsPickerTitle>
        <BannerInformationAboutFlightTypes />
        {hasResults && <FlightClassSwitcher />}
        {!archivedAt && (
          <Experiment name={EXPERIMENT_NAMES.ACTUALIZE_ALTERNATIVES.NAME}>
            <Variant
              option={EXPERIMENT_NAMES.ACTUALIZE_ALTERNATIVES.OPTIONS.ON}
            >
              <FlightsProgressbar />
            </Variant>
          </Experiment>
        )}
        <LuggageFilterPanel />
        {!hasResults && !isLoading && (
          <div className={`${baseCls}__empty`}>
            <FlightsNoResults />
          </div>
        )}
        <FlightsLoadingResults
          isLoading={isLoading}
          id={FLIGHT_LIST_ID}
          isMobile={isMobile}
        />
        {/** TODO: Вернуть обратно, когда разберемся как этот блок должен работать с соседними рейсами
         * @see https://leveltravel.atlassian.net/browse/LT-25919
         * {paidFlightLock && <LockFlightAlert price={flightLockExtra.price} />}
         */}
      </div>
    );
  }
}

const LuggageFilterPanel = styled(LuggageFilterPanelComponent)`
  margin-bottom: 16px;
`;

const FlightsPickerTitle = styled.h2`
  margin-bottom: 8px;
  padding-left: 8px;

  display: flex;
  align-items: center;
  gap: 4px;
`;

const BannerInformationAboutFlightTypes = styled(InformationAboutFlightTypes)`
  margin-bottom: 16px;
`;

const mapStateToProps = (state) => {
  const { OPTIONS, NAME } = EXPERIMENT_NAMES.ACTUALIZE_ALTERNATIVES;
  const actualizeAlternativesAllowed = getIsFeatureHasAnOption(
    NAME,
    OPTIONS.ON,
  );
  return {
    flightsCount: flightsCountSelector(state),
    isLoading: isFlightListLoading(state, actualizeAlternativesAllowed),
    isMobile: getIsMobile(state),
    archivedAt: getArchivedAt(state),
  };
};

export default connect(mapStateToProps)(FlightsList);
